// extracted by mini-css-extract-plugin
export var lg = "_1z-4";
export var md = "_1z-3";
export var sm = "_1z-2";
export var xs = "_1z-1";
export var xxs = "_1z-0";